import { atom } from "jotai";

// Whether the Manage Options modal is visible. Single source of truth for the
// overlay, opened from the Inventory top bar "Manage Options" button.
export const isManageOptionsOpenAtom = atom(false);
